import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocViewerComponent } from './doc-viewer/doc-viewer.component';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { DocViewerDialogComponent } from './doc-viewer-dialog/doc-viewer-dialog.component';
import {DialogModule} from 'primeng/dialog';
import {DynamicDialogModule} from 'primeng/dynamicdialog';



@NgModule({
  declarations: [DocViewerComponent, DocViewerDialogComponent],
  imports: [
    CommonModule, ProgressSpinnerModule, DialogModule, DynamicDialogModule
  ],
  exports: [DocViewerDialogComponent, DocViewerComponent]
})
export class DocViewerModule { }
